import React, { useReducer } from "react";
import { Modal, Popup, Icon } from "semantic-ui-react";
import AddToWaitingList from "../../ActPatient/Steps/AddToWaitingList";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";

function Note(props) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const { getAtesData } = props;

  return (
    <>
      <Popup
        content="modifier une presentation"
        trigger={
          <Icon
            circular
            inverted
            color="violet"
            // floated="left"
            onClick={() => dispatch({ type: ACTION.OPEN, size: "small" })}
            name="edit"
            size="large"
            className="centerIcon_And_Float_Right"
          />
        }
      />
      <Modal
        size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
      >
        <Modal.Header className="center3columnheaders">
          Modification une presentation
        </Modal.Header>
        <Modal.Content>
          <AddToWaitingList getAtesData={getAtesData} />
        </Modal.Content>
      </Modal>
    </>
  );
}

export default Note;
